import style from './conhecerMais.module.scss';

const parse = require('html-react-parser');

interface Dados {
  dados: {
    banner: string;
    texto1: string;
    texto2: string;
  };
}

export default function Conhecermais({ dados }: Dados) {
  if (!dados) return null;

  return (
    <div className={style.section}>
      <p>{parse(dados.texto1)}</p>
      <div>
        <p>{parse(dados.texto2)}</p>
        <a
          href='https://www.plugape.com.br/'
          target='_blank'
          rel='noreferrer'>
          Conheça mais sobre a
          {' '}
          <span>Plug Apê</span>
        </a>
      </div>
    </div>
  );
}
